<template>
  <teleport to="body">
    <transition leave-active-class="duration-200">
      <div
        v-show="show"
        class="fixed inset-0 overflow-y-auto px-4 py-6 z-50"
        :class="extraFlex"
        scroll-region
      >
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-show="show"
            class="fixed inset-0 transform transition-all"
            @click="close"
          >
            <div
              class="absolute inset-0 bg-gray-500 opacity-75"
              :class="$attrs['blur-class']"
            />
          </div>
        </transition>

        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            v-show="show"
            class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm2:mx-auto"
            :class="[maxWidthClass, extraClass]"
          >
            <slot v-if="show" />
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import { useNotification } from "@kyvg/vue3-notification";

const { notify } = useNotification();

export default {

        props: {
            show: {
                default: false
            },
            maxWidth: {
                default: '2xl'
            },
            closeable: {
                default: true
            },
            persistentMessage: {
                default: '',
                require: false
            },
            extraClass: {
                default: '',
                require:false
            },
            extraFlex:{
                default: '',
                require:false
            }
        },
        emits: ['close'],

        setup(props, {emit}) {
            const close = () => {
                if (props.closeable) {
                    emit('close')
                }

                if (!props.closeable && !!props.persistentMessage) {
                    notify({
                        title: props.persistentMessage,
                        type: "error",
                    });
                }
            }

            const closeOnEscape = (e) => {
                if (e.key === 'Escape' && props.show) {
                    close()
                }
            }

            onMounted(() => document.addEventListener('keydown', closeOnEscape))
            onUnmounted(() => document.removeEventListener('keydown', closeOnEscape))

            return {
                close,
            }
        },

        computed: {
            maxWidthClass() {
                return {
                    'sm': 'sm:max-w-sm',
                    'md': 'sm:max-w-md',
                    'lg': 'sm:max-w-lg',
                    'xl': 'sm:max-w-xl',
                    '2xl': 'sm:max-w-2xl',
                    '3xl': 'sm:max-w-3xl',
                }[this.maxWidth]
            }
        },

        watch: {
            show: {
                immediate: true,
                handler: (show) => {
                    if (show) {
                        document.body.style.overflow = 'hidden'
                    } else {
                        document.body.style.overflow = null
                    }
                }
            }
        }
    }
</script>
<style scoped>
.wizard-box {
    max-width: unset !important;
    width: 1195px !important;
    background: #F3F4F6 !important;
}

.modal-migrate-box {
   width: 485px;
}

.modal-margin{
    margin-top: 0 !important;
}
.modal-width {
    width: 1280px;
    max-width: unset;
    filter: drop-shadow(0px 24px 36px rgba(0, 35, 31, 0.12));
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(32px);
}
.modal-guidelines-width {
    width: 1000px;
    max-width: unset;
    filter: drop-shadow(0px 24px 36px rgba(0, 35, 31, 0.12));
    border-radius: 16px ;
}
.iframe-modal{
    width: 900px;
}
.background-opacity{
    opacity: 0.6;
}
.chat-modal{
    width: 561px;
}
.upgrade-modal{
    width: 620px;
    border-radius: 16px;
}
.upgrade-user-modal {
    width: 873px;
    border-radius: 6px;
    max-width: 100%;
    overflow-y: auto;
}
.opacity-class{
    opacity: 0.4;
}
.login-modal{
    width: 1400px;
    max-width: unset;
    max-height: 950px;
    overflow: auto;
}
.go-live-modal{
    width: 1024px;
    overflow-y: auto;
    max-width: unset;
    border-radius: 16px;
}
.go-live-connected-modal{
    width: auto;
    overflow-y: auto;
    max-width: unset;
    border-radius: 8px;    
    height: auto;
}
.site-modal{
    width: 572px;
    border-radius: 16px;
}
.cache-modal{
    width: 520px !important;
}
.remove-modal{
    width: 560px !important;
}

.order-modal{
    width: 400px !important;
}
.setting-team-modal{
    width: 560px !important;
}
.site-template-modal{
    max-width: 660px !important;
}
.site-template-modal-new{
    max-width: 650px !important;
}
.install-plugin-modal{
    width: 900px !important;
}
@media screen and (max-width:1480px) and (max-height:800px) {
    .chat-height{
        max-height: 700px;
        overflow: auto;
    }
}
@media screen and (max-width:991px) {
    .modal-width {
        width: 100%;
        max-width: unset;
        min-height:auto;
    }
    .login-modal{
        width: 100%;
        max-width: unset;
        min-height:auto;
    }
    .go-live-modal{
        width: 100%;
        max-width: unset;
        min-height:auto;
    }
    .iframe-modal{
        width: 100%;
    }
    .chat-modal{
        width: 100%;
    }
    .upgrade-modal{
        width: 100%;
    }
    .upgrade-user-modal {
        width: 100%;
        border-radius: 6px;
        max-width: 100%;
    }
    .site-modal{
        width: 100%;
    }
    .go-live-new-modal{
        height: 100% !important;
    }
    .install-plugin-modal{
        width: 100% !important;
    }
}

@media (min-height:700px) {
    .modal-custom-height{
        align-items: center !important ;
    }
}
@media (max-height:800px) {
    .site-template-modal-height,.order-modal-height,
    .save-template-modal-height, .integration-modal, .wizard-modal, .staging-site-modal, .plan-modal-height{
        align-items: flex-start !important;
    }
}
@media (max-height:650px) {
    .buy-template-height, .code-editor-modal-height{
        align-items: flex-start !important;
    }
}
</style>